// API関連定数

export const API_ENDPOINTS = {
  // 認証関連
  AUTH: '/api/auth/',
  REGISTER: '/api/auth/register/',
  LOGIN: '/api/auth/login/',
  LOGOUT: '/api/auth/logout/',
  REFRESH: '/api/auth/refresh/',
  
  // サブスクリプション関連
  SUBSCRIPTION_PLANS: '/api/auth/subscription-plans/',
  USER_SUBSCRIPTION: '/api/auth/user-subscription/',
  
  // ユーザー関連
  USER_PROFILE: '/api/auth/user/',
  USER_UPDATE: '/api/auth/user/update/',
  
  // 3D Analyzer関連
  GET_3D_ANALYZER_TOKEN: '/api/auth/3danalyzer/token/',
} as const;

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
} as const;

export const REQUEST_TIMEOUT = {
  DEFAULT: 5000,  // 5秒（短縮）
  UPLOAD: 15000,  // 15秒（短縮）
  DOWNLOAD: 30000, // 30秒（短縮）
} as const; 